import getAllFocusable from './get-all-focusables';

export default function (element) {
	const focusableElements = getAllFocusable();
	const targetIndex = focusableElements.indexOf(element);
	if (targetIndex === -1) {
		const errorMessage = 'Next focusable not found, is the argument  focusable?';
		throw errorMessage;
	}
	return targetIndex < focusableElements.length - 1 ? focusableElements[targetIndex + 1] : focusableElements[0];
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/focus/get-next-focusable.js